var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g(_vm._b({attrs:{"disabled":!_vm.value},on:{"click":_vm.copy}},'v-btn',_vm.$attrs,false),on),[_vm._v(" CSV ")])]}}])},[_c('span',[_vm._v("in Zwischenablage kopieren")])])
}
var staticRenderFns = []

export { render, staticRenderFns }